import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { from, Observable, Subject, SubscriptionLike } from 'rxjs';
import { AtsResumeScreenService } from 'src/app/_services/ats-resume-screen.service';
import { GenAiJdSearchComponent } from 'src/app/gen-ai-jd-search/gen-ai-jd-search.component';
import { JdData } from 'src/app/common-interfaces-classes/JdData';
import { JdDataService } from 'src/app/jd-data.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { GlobalService } from 'src/app/_services/global.service';
import { SearchtoolboxService } from 'src/app/_services/searchtoolbox.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { MatAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

export type TextExtractResponse = {
  status: 'success' | 'failure',
  text: string,
  message: string
};

@Component({
    selector: 'app-create-job',
    templateUrl: './create-job.component.html',
    styleUrls: ['./create-job.component.scss'],
    standalone: false
})
export class CreateJobComponent implements OnInit {


  /** Project Creation flow for ATS jobs */
  jobTitlesInput: UntypedFormControl = new UntypedFormControl(null);
  jobTitlesInputError: boolean = false;

  locationInput: UntypedFormControl = new UntypedFormControl(null);
  locationInputError: boolean = false;

  industryInput: UntypedFormControl = new UntypedFormControl(null);
  industryInputError: boolean = false;

  jdInput: UntypedFormControl = new UntypedFormControl(null);
  jdInputError: boolean = false;

  showSubmitJdSpinner: boolean = false;
  submitJdLoader: boolean = false;
  showCriteria: boolean = false;
  showFullDescription: boolean = false;

  jobid: string = '';
  jobDetails: any = {};
  calledfrom: string = '';
  changedJD: boolean = false;

  locationlist: any = [];


  isUploadedFileCorrect = false;
  incorrectFileFormat = false;
  specialCharaterError = false;
  fileSizeLimitExceeded = false;
  jdDataLoading = false;
  textExtractionError = false;
  uploadedFilename: string;
  uploadedFile = null;
  textExtractionErrorMessage: string;

  subscriptionsLike: SubscriptionLike[] = [];
  enterManualEvent: boolean = false;

  constructor(
    private modelService: NgbModal,
    private router: Router,
    private atsResumeScreenService: AtsResumeScreenService,
    private jdDataService: JdDataService,
    private localStorageService: LocalStorageService,
    private searchtoolbox: SearchtoolboxService,
    private personSearchService: PersonSearchService
  ) { }

  ngOnInit() {

    const storedJobDetails = JSON.parse(this.localStorageService.getItem('jobdetails'));
    
    if (storedJobDetails) {
      this.jobDetails = storedJobDetails;
      this.calledfrom = storedJobDetails?.calledfrom;
      if (this.calledfrom === 'job-create') {
        this.jobTitlesInput.setValue(this.jobDetails?.data?.jobtitle);
        this.locationInput.setValue(this.jobDetails?.data?.location);
        this.industryInput.setValue(this.jobDetails?.data?.industry);
        this.jdInput.setValue(this.jobDetails?.data?.description);

      } else {
        this.jobTitlesInput.setValue(null);
        this.locationInput.setValue(null);
        this.industryInput.setValue(null);
        this.jdInput.setValue(null);
      }

    } else {
      this.jobDetails = {};
      this.calledfrom = 'job-create';
    }

    // this.jobTitlesInput.valueChanges.subscribe((value) => {
    //   const inputRegex = /^[a-zA-Z0-9\-'\.,@&\/\+\:\#_\(\)\"\'\* ]*$/;
    //   if (value && value.length > 0 && !inputRegex.test(value)) {
    //     this.projectnameSpecialCharError = true;
    //   } else {
    //     this.projectnameSpecialCharError = false;
    //   }
    // });

    this.jdInput.valueChanges.subscribe((value) => {
      this.changedJD = true;
      this.showCriteria = false;
    });

  };


  /**
    * Get job detaiils 
    */
  getJobDetails() {
    this.atsResumeScreenService.getJobDetails(this.jobid).subscribe((response: any) => {
      if (response && response.success) {
        this.jobDetails = response.data;
      } else {
        this.jobDetails = {};
      }
    })
  };



  /**
    * Method to submit the job description.
    */
  submitJD() {

    if (!this.jdInput.value?.trim()) return;
    if (!this.jobTitlesInput.value?.trim()) {
      this.jobTitlesInputError = true;
      return
    }
    this.submitJdLoader = true;
    this.changedJD = false;
    this.localStorageService.clearItem('jobdetails');

    const modalRef = this.modelService.open(
      GenAiJdSearchComponent,
      { windowClass: 'genAimodal', centered: true, backdrop: 'static', keyboard: false }
    );
    const modalInstance: GenAiJdSearchComponent = modalRef.componentInstance;
    modalInstance.description = this.jdInput.value;
    modalInstance.calledFrom = 'resume-screen';

    const modalResult$ = from(modalRef.result);

    modalResult$.subscribe((response: JdData) => {
      if (response && response.status == 'success') {
        this.showCriteria = true;
        const jobDetails = {
          calledfrom: 'job-create',
          data: {
            name: this.jobTitlesInput.value,
            location: this.locationInput.value,
            industry: this.industryInput.value,
            description: this.jdInput.value,
          },
          parshedJD: response
        };
        this.localStorageService.setItem('jobdetails', JSON.stringify(jobDetails));
        this.jdDataService.emitJDDataEvent(response);
      } else {
        this.jdInput.setValue(null);
      }
      this.submitJdLoader = false;

    });
  };


  /**
   * Method to upload a file.
   * @param event
   */
  uploadFile(event: any) {

    this.resetFormFields();
    const oldFile = event.target.files[0];
    this.uploadedFile = GlobalService.validateAndSanitizeFile(oldFile);
    this.validateInputFile();
    // this.aiSourcingHandlerService.setEnterManualEvent(true);

    if (this.uploadedFile && !this.specialCharaterError && !this.incorrectFileFormat && !this.fileSizeLimitExceeded) {
      this.isUploadedFileCorrect = true;
      this.uploadedFilename = oldFile.name;
      this.jdDataLoading = true;

      this.searchtoolbox.documentToText(this.uploadedFile).subscribe((response: TextExtractResponse) => {
        this.jdDataLoading = false;
        this.processTextractResponse(response);
      }, () => this.jdDataLoading = false);
    }
  };

  getautocompleteData(type, input): Observable<any> {
      var subject = new Subject<any>();
      this.personSearchService.getPersonSearchListing(input, type).subscribe((res: any) => {
        if (res.status == "success") {
          const locations = res.data.map((item: any) => ({
            ...item,
            value: this.toTitleCase(item.value)
          }));
          subject.next(locations);
        } else {
          subject.next([]);
        }
      });
      return subject.asObservable();
    }

  /** Converts a string to camelCase (e.g. "New York" → "newYork") */
  toTitleCase(value: string): string {
    return value
      .replace(/\b\w/g, (char: string) => char.toUpperCase());
  }

  displayFn(value: string): string {
    return value || '';
  }

  onLocationSelected(event: MatAutocompleteSelectedEvent): void {
    this.locationInput.setValue(this.toTitleCase(event.option.value), { emitEvent: false });
  }

  //Typeahead for Location
  searchLocation(e) {
    if (e.target.value != "" && e.target.value.length > 2) {
      this.getautocompleteData("location", e.target.value).subscribe((res) => {
        this.locationlist = res;
      });
    } else {
      this.locationlist = [];
    }
  }


  /**
    * Method to validate the uploaded file.
    */
  private validateInputFile() {
    const validFileExtensions = ['doc', 'docx', 'pdf', 'txt', 'odt'];
    const uploadedFileExtension = this.uploadedFile?.name?.split('.')[1];

    if (!validFileExtensions.includes(uploadedFileExtension.toLowerCase())) {
      this.incorrectFileFormat = true;
    }

    // Verify file size (File size cannot exceed 5 MB)
    if (this.uploadedFile.size > 5242880) {
      this.fileSizeLimitExceeded = true;
    }
  };

  /**
   * Method to set extracted text to the job description input.
   * @param response
   */
  private processTextractResponse(response: TextExtractResponse) {
    if (response.status === "success") {
      this.jdInput.setValue(response.text);
      this.textExtractionError = false;
      this.textExtractionErrorMessage = null;
    }
    else if (response.status === "failure") {
      this.textExtractionError = true;
      this.textExtractionError = true;
      this.textExtractionErrorMessage = response.message;
    }
  };

  /**
   * Method to reset form fields.
   */
  resetFormFields() {
    // this.aiSourcingHandlerService.setEnterManualEvent(true);
    this.incorrectFileFormat = false;
    this.specialCharaterError = false;
    this.isUploadedFileCorrect = false;
    this.uploadedFilename = null;
    this.fileSizeLimitExceeded = false;
    this.jdInput.setValue(null);
  }

  /**
   * Handle view more or less jo description text
   * @param viewtext 
   */
  viewMoreLessDescription(viewtext: string) {
    if (viewtext == 'view-more') {
      this.showFullDescription = true;
    } else {
      this.showFullDescription = false;
    }
  };

  /**
   * Method to handle the dismiss all event.
   */
  dismiss() {
    this.modelService.dismissAll();
  };

}
